import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, PaginationSearchModel } from '@data-layer/models/common';
import { ManagementHouseBillModel, ManagementPackingListModel, ManagementUpdatePackingListModel } from '@data-layer/models/management';

@Injectable({
  providedIn: 'root',
})
export class PackingListsRepository {
  constructor(private apiService: ApiService) {}

  public search(
    params?: PaginationSearchModel,
    isShowLoader?: boolean,
    isUsed: boolean = false,
  ): Observable<PaginatedResultModel<ManagementPackingListModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementPackingListModel>>(
      environment.url.freight.packingListsManagement,
      { params },
      { isShowLoader, isUsed },
    );
  }

  public searchByHouseBillId(
    houseBillId: ManagementHouseBillModel['id'],
    params: PaginationSearchModel,
    isShowLoader?: boolean,
  ): Observable<PaginatedResultModel<ManagementPackingListModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementPackingListModel>>(
      `${environment.url.freight.houseBillsManagement}/${houseBillId}/packing-lists`,
      { params },
      {
        isShowLoader,
      },
    );
  }

  public create(
    houseBillId: ManagementHouseBillModel['id'],
    model: ManagementUpdatePackingListModel,
    isShowLoader?: boolean,
  ): Observable<ManagementPackingListModel> {
    return this.apiService.post<ManagementPackingListModel>(
      `${environment.url.freight.houseBillsManagement}/${houseBillId}/packing-lists`,
      model,
      null,
      {
        isShowLoader,
      },
    );
  }

  public get(id: ManagementPackingListModel['id'], isShowLoader?: boolean): Observable<ManagementPackingListModel> {
    return this.apiService.get<ManagementPackingListModel>(`${environment.url.freight.packingListsManagement}/${id}`, null, {
      isShowLoader,
    });
  }

  public update(
    id: ManagementPackingListModel['id'],
    model: ManagementUpdatePackingListModel,
    isShowLoader?: boolean,
  ): Observable<ManagementPackingListModel> {
    return this.apiService.put<ManagementPackingListModel>(`${environment.url.freight.packingListsManagement}/${id}`, model, null, {
      isShowLoader,
    });
  }

  public delete(id: ManagementPackingListModel['id'], isShowLoader?: boolean): Observable<never> {
    return this.apiService.delete(`${environment.url.freight.packingListsManagement}/${id}`, null, { isShowLoader });
  }
}
